import { useCallback, useState } from "react"
import { useReactFlow } from "@xyflow/react"

export default function CustomControls({ onAutoLayout }) {
  const { zoomIn, zoomOut, fitView } = useReactFlow()

  const handleZoomIn = useCallback(() => {
    zoomIn({ duration: 200 })
  }, [zoomIn])

  const handleZoomOut = useCallback(() => {
    zoomOut({ duration: 200 })
  }, [zoomOut])

  const handleFitView = useCallback(() => {
    fitView({ padding: 0.2, duration: 200 })
  }, [fitView])

  return (
    <div className="react-flow__controls" style={{ position: 'absolute', left: 10, bottom: 10, zIndex: 5 }}>
      <button
        type="button"
        className="react-flow__controls-button react-flow__controls-zoomin"
        onClick={handleZoomIn}
        title="Zoom In"
        aria-label="Zoom In"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <path d="M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z" />
        </svg>
      </button>
      <button
        type="button"
        className="react-flow__controls-button react-flow__controls-zoomout"
        onClick={handleZoomOut}
        title="Zoom Out"
        aria-label="Zoom Out"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <path d="M0 13.867h32v4.266H0z" />
        </svg>
      </button>
      <button
        type="button"
        className="react-flow__controls-button react-flow__controls-fitview"
        onClick={handleFitView}
        title="Fit View"
        aria-label="Fit View"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <path d="M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z" />
        </svg>
      </button>
      <button
        type="button"
        className="react-flow__controls-button"
        onClick={() => onAutoLayout?.()}
        title="Auto Layout"
        aria-label="Auto Layout"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
          <path d="M4 4h8v8H4zm0 12h8v8H4zm12-12h8v8h-8zm0 12h8v8h-8z" opacity="0.3" />
          <path d="M2 2h12v12H2V2zm2 2v8h8V4H4zM16 2h12v12H16V2zm2 2v8h8V4h-8zM2 16h12v12H2V16zm2 2v8h8v-8H4zm12-2h12v12H16V16zm2 2v8h8v-8h-8z" />
        </svg>
      </button>
    </div>
  )
}
